import { Backdrop, CircularProgress } from '@mui/material';

const Loader = () => (
  <Backdrop
    sx={{ backgroundColor: 'rgb(255 255 255 / 50%)', zIndex: 1301 }}
    open={true}
  >
    <CircularProgress sx={{ color: '#DC0032' }} size={60} />
  </Backdrop>
);

export default Loader;
